export default {
  page: 1,
  size: 50,
  count: 0,
  indexStartsFrom: 1,
  pages: 1,
  sort: {},
  filters: {},
};
